import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box, FormControlLabel, FormHelperText } from '@material-ui/core'

import { PropFilter } from './PropFilter'
import { PropFilterItemBase } from './StringPropFilter'

import { emDash } from '../common/stringUtility'

export type StoreTableHasMsProductFilterBaseProps =
  Pick<PropFilterItemBase, 'value' | 'setValue' | 'readOnly'>

export const StoreTableHasMsProductFilterBase =
  observer(
    (props: StoreTableHasMsProductFilterBaseProps) =>
      <>
        <FormControlLabel
          labelPlacement="start"
          label={<span style={{fontSize: 12}}>Сматчен с МоимСкладом</span>}
          control={
            <Box marginLeft={1}>
              <PropFilter
                filter={{
                  ...props,
                  isBoolean: true,
                  placeholder: emDash,
                  onText: 'да',
                  offText: 'нет'
                }}
              />
            </Box>}
        />

        <FormHelperText>&nbsp;{/*spacer*/}</FormHelperText>
      </>)